import * as React from "react"
import {isEmpty as _isEmpty} from "lodash";
import { IPrescription, IAppointmentScheduleResponse } from "@curefit/care-common";
import {EditViewDisplayMode} from "../../components/common/EditViewCard";
import IDifferentialDiagnosis from "../../models/IDifferentialDiagnosis";
import IDoctorProfile from "../../models/IDoctorProfile";
import { IOngoingConsultation } from "../../models/IOngoingConsultation";
import ModelFactory from "../../models/ModelFactory";
import IPatientCompleteInfo from "../../models/patients/IPatientCompleteInfo";
import { AppMessages, ConsultationStatusConstant, toastNotificationAppearance } from "../../utils/AppConstants";
import { default as AppUtils, LOADING_STATE } from "../../utils/AppUtils";
import DifferentialDiagnosisEditViewCont from "../EditView/DifferentialDiagnosisEditViewCont";

export interface PrivateNotesModalProps {
    appointmentId: number,
    bookingId: number,
    patientDifferentialDiagnosis: IDifferentialDiagnosis,
    saveDifferentialDiagnosis: (appointmentId: number, differentialDiagnosis: IDifferentialDiagnosis) => Promise<any>,
    updateAppointmentStatus: (bookingId: number, appointmentId: number, status: ConsultationStatusConstant) => Promise<any>,
    // navigateToDashboard: () => any,
    patientDetails: IPatientCompleteInfo,
    ongoingConsultation: IOngoingConsultation
    showLoginPrompt: () => void
    getMedicalProfile: (patientId: number, appointmentId: number, doctorType: string) => Promise<any>,
    patientId: number,
    doctorType: string,
    curefitUserId: number,
    fetchOngoingConsultation: (patientId: number, appointmentId: number, curefitId: number, isSelf: boolean, doctorProfile: IDoctorProfile) => Promise<any>,
}

export interface PrivateNotesModalState {
    updateAppointmentRetries: number,
    modalErrorText: string,
    differentialDiagnosisSavingState: LOADING_STATE
}

class PrivateNotesModal extends React.Component<PrivateNotesModalProps, PrivateNotesModalState> {
    constructor(props: PrivateNotesModalProps) {
        super(props)
        this.state = {
            updateAppointmentRetries: 0,
            modalErrorText: "",
            differentialDiagnosisSavingState: LOADING_STATE.NOT_INITIALIZED
        }
    }

    preventModalClose = (event: any) => {
        event.stopPropagation();
    }

    saveDifferentialDiagnosis = (differentialDiagnosis: IDifferentialDiagnosis) => {
        let myInstance = this;
        this.setState({differentialDiagnosisSavingState: LOADING_STATE.LOADING})
        if (ModelFactory.isValidDifferentialDiagnosis(differentialDiagnosis)) {
            this.props.saveDifferentialDiagnosis(this.props.appointmentId, differentialDiagnosis).then((updatedPrescription: IPrescription) => {
                AppUtils.triggerToastNotification(AppMessages.SAVE_PRIVATE_NOTES_SUCCESSFUL, toastNotificationAppearance.success)
                myInstance.props.showLoginPrompt();
            }).catch(error => {
                AppUtils.triggerToastNotification(AppMessages.SAVE_PRIVATE_NOTES_UNSUCCESSFUL, toastNotificationAppearance.success)
                myInstance.props.showLoginPrompt();
            });
        } else {
            myInstance.props.showLoginPrompt();
        }
    }

    // verifyConsultationStatusUpdate = () => {
    //     let myInstance = this;
    //     let retries = this.state.updateAppointmentRetries;
    //     this.props.fetchAppointmentById(this.props.appointmentId).then((apptResponse: IAppointmentScheduleResponse[]) => {
    //         let appointment = apptResponse[0];
    //         if (appointment.status === ConsultationStatusConstant.COMPLETED) {
    //             myInstance.setState({differentialDiagnosisSavingState: LOADING_STATE.LOADED})
    //             myInstance.props.showLoginPrompt();
    //         } else {
    //             if (retries < AppConstants.UPDATE_APPOINTMENT_STATUS_MAX_RETRIES_COUNT) {
    //                 this.setState({
    //                     updateAppointmentRetries: retries + 1
    //                 }, this.updateAppointmentStatus)
    //             } else {
    //                 myInstance.setState({
    //                     differentialDiagnosisSavingState: LOADING_STATE.LOADED,
    //                     modalErrorText: "Could not update appointment status"
    //                 })
    //             }
    //         }
    //     })
    // }

    updateAppointmentStatus = () => {
        let myInstance = this;
        this.props.updateAppointmentStatus(this.props.bookingId, this.props.appointmentId, ConsultationStatusConstant.COMPLETED).then((consultation: IAppointmentScheduleResponse[]) => {
            myInstance.props.showLoginPrompt();
        }).catch(error => {
            myInstance.setState({
                differentialDiagnosisSavingState: LOADING_STATE.LOADED,
                modalErrorText: "Could not update appointment status"
            })
        });
    }

    render() {
        let differentialDiagnosisObject = ModelFactory.createNewDifferentialDiagnosis();
        if ( !_isEmpty(this.props.ongoingConsultation) && !_isEmpty(this.props.ongoingConsultation.currentPrescription) ) {
            differentialDiagnosisObject.differentialDiagnosis = this.props.ongoingConsultation.currentPrescription.differentialDiagnosis;
            differentialDiagnosisObject.notes = this.props.ongoingConsultation.currentPrescription.notes;
        }
        return (
            <div className={"differential-diagnosis-container"} onClick={this.preventModalClose}>
                <h3>{`Private Notes for ${this.props.patientDetails.profile.name}`}</h3>
                <DifferentialDiagnosisEditViewCont appointmentId={this.props.appointmentId}
                                                   patientDifferentialDiagnosis={differentialDiagnosisObject}
                                                   saveDifferentialDiagnosis={this.saveDifferentialDiagnosis}
                                                   showLoginPrompt={this.props.showLoginPrompt}
                                                   displayMode={EditViewDisplayMode.EDIT}
                                                   differentialDiagnosisSaveState={this.state.differentialDiagnosisSavingState}
                                                   doctorType={this.props.doctorType}
                                                   curefitUserId = {this.props.curefitUserId.toString()}/>
                {
                    !_isEmpty(this.state.modalErrorText) &&
                    <div>
                        <div className={"error-response"}>
                            {this.state.modalErrorText}
                            <input className="card-primary-action send-prescription" type="button" value="End anyways" onClick={this.props.showLoginPrompt} />
                        </div>
                    </div>
                }
            </div>
        )
    }
}

export default PrivateNotesModal;